import {KeypadControlsDuringAutoplayGameState} from '@gongxigames/framework/slot/modules/keypadControls/states/KeypadControlsDuringAutoplayGameState';
import {GenericPopupEvents, GenericPopupType} from '@gongxigames/framework/slot/modules/genericPopup';
import {KeypadControlsModule} from '@gongxigames/framework/slot/modules/keypadControls/KeypadControlsModule';

export class KeypadControlsDuringAutoplayFreeSpinsState extends KeypadControlsDuringAutoplayGameState {

    protected setupEvents(): void {
        super.setupEvents();

        this.setEventHandler(GenericPopupEvents.POPUP_CLOSED, this.onPopupClosed.bind(this));
    }

    protected onPopupClosed(type: symbol): void {
        if (type === GenericPopupType.FREESPIN_OUTRO) {
            this.onFreeSpinsOutroFinished();
        }
    }

    protected onFreeSpinsOutroFinished(): void {
        this.module.gotoState(KeypadControlsModule.AUTOPLAY_STATE);
    }
}
